module.exports = __webpack_public_path__ + "static/media/mainpicture_Giztixwebsite_m.21dbae8f.webp";